module.exports = __webpack_public_path__ + "img/imagem_fundo_home.e0248aec.jpg";